import { useMemo, useState } from 'react'
import { CheckSquare, List, MagnifyingGlass } from 'phosphor-react'
import { CustomButton } from '../../../components/CustomButton'
import Navbar from '../../../components/navbar/navbar'
import { CustomInput } from '../../../components/CustomInput'
import { ModalSelectProduct } from './ModalSelectProduct'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import WmsProductService from '../../../services/database/WmsProductService'
import { Col, Form, Row, Table } from 'react-bootstrap'
import WmsAddressService from '../../../services/database/WmsAddressService'
import { CustomSpinner } from '../../../components/CustomSpinner'
import ReactPaginate from 'react-paginate'
import { ModalConfirmQuantity } from './ModalConfirmQuantity'
import { HousesFill, PlusCircleFill, TrashFill } from 'react-bootstrap-icons'
import { v4 } from 'uuid'

import {
  AddressFrom,
  AddressSection,
  AddressTitle,
  AddressTo,
  ButtonView,
  Container,
  Content,
  FormPage,
  Group,
  ListPage,
  Tab,
  Tabs,
  Title,
} from './styles'
import { Ask } from '../../../components/Ask'
import { toast } from 'react-toastify'
import { getValue } from '../../../utils/getValue'

export function WMSTransferenciaEndereco() {
  const [search, setSearch] = useState(null)
  const [activeTab, setActiveTab] = useState('selection')
  const [selectedProduct, setSelectedProduct] = useState({})
  const [fromAddress, setFromAddress] = useState({})
  const [toAddress, setToAddress] = useState({})
  const [isModalSelectProductOpen, setIsModalSelectProductOpen] =
    useState(false)
  const [isModalConfirmQuantityOpen, setIsModalConfirmQuantityOpen] =
    useState(false)
  const [products, setProducts] = useState([])
  const [isProductsLoading, setIsProductsLoading] = useState(false)
  const [addresses, setAddresses] = useState([])
  const [isAddressesLoading, setIsAddressesLoading] = useState(false)
  const [searchAddress, setSearchAddress] = useState({
    codendereco: '',
    tipoender: '',
    situacao: '',
    deposito: '',
    rua: '',
    predio: '',
    nivel: '',
    apto: '',
    codendereco: '',
  })
  const [isAddressSearchLoading, setIsAddressSearchLoading] = useState(false)
  const [transfers, setTransfers] = useState([])
  const [addressesDelete, setAddressesDelete] = useState([])
  const [isTransferAddressesLoading, setIsTransferAddressesLoading] =
    useState(false)

  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)

  const endOffset = itemOffset + 10

  const filteredAddresses = useMemo(() => {
    setPageCount(Math.ceil(addresses.length / 10))

    return addresses.slice(itemOffset, endOffset)
  }, [addresses, itemOffset, endOffset])

  function handlePageClick(event) {
    const newOffset = (event.selected * 10) % addresses.length

    setItemOffset(newOffset)
  }

  function handleChangeSearchAddress(e) {
    const { name, value } = e.target

    setSearchAddress((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  function handleRemoveAddresses() {
    for (const addressDelete of addressesDelete) {
      setTransfers((prevState) =>
        prevState.filter((transfer) => transfer.id !== addressDelete),
      )
    }

    setAddressesDelete([])
  }

  function resetStates() {
    setFromAddress({})
    setToAddress({})
    setSelectedProduct({})
    setAddresses([])
  }

  async function handleProductProcess(data) {
    const existsAddress = transfers.findIndex(
      (transfer) =>
        transfer.toAddress.codendereco == data.toAddress.codendereco &&
        transfer.product.sku != selectedProduct.sku,
    )

    const addToList = () => {
      const dataFormatted = {
        id: v4(),
        product: selectedProduct,
        ...data,
      }

      setIsModalConfirmQuantityOpen(false)
      resetStates()
      setTransfers((prevState) => [...prevState, dataFormatted])
    }

    if (existsAddress !== -1) {
      Ask('Endereço ocupado, deseja selecionar assim mesmo?', () => addToList())
    } else {
      addToList()
    }
  }

  async function handleSearchAddress() {
    try {
      setIsAddressSearchLoading(true)

      const data = await WmsAddressService.searchBySKU({
        sku: selectedProduct.sku,
        codendereco: searchAddress.codendereco,
        deposito: searchAddress.deposito,
        rua: searchAddress.rua,
        predio: searchAddress.predio,
        apto: searchAddress.apto,
        nivel: searchAddress.nivel,
        situacao: searchAddress.situacao,
        tipoender: searchAddress.tipoender,
      })

      setAddresses(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível pesquisa os endereços!')
    } finally {
      setIsAddressSearchLoading(false)
    }
  }

  async function searchProducts() {
    try {
      setIsProductsLoading(true)

      const data = await WmsProductService.searchProducts(search)

      setProducts(data)
      setIsModalSelectProductOpen(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível listar os produtos!')
    } finally {
      setIsProductsLoading(false)
    }
  }

  async function loadAddressesBySKU(sku) {
    try {
      setIsAddressesLoading(true)

      const data = await WmsAddressService.getAllBySKU(sku)

      setAddresses(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar os endereços!')
    } finally {
      setIsAddressesLoading(false)
    }
  }

  function handleSelectProduct(product) {
    setSearch('')
    setSelectedProduct(product)
    setIsModalSelectProductOpen(false)
    loadAddressesBySKU(product.sku)
  }

  async function handleTransferAddresses() {
    try {
      setIsTransferAddressesLoading(true)

      await WmsAddressService.transferAddresses(transfers)

      toast.success('Transferência realizada com sucesso!')
      setTransfers([])
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível transferir os endereços!')
    } finally {
      setIsTransferAddressesLoading(false)
    }
  }

  return (
    <>
      <Container>
        <Navbar />

        <Content>
          <Title>Transferência de Endereço</Title>

          <Tabs>
            <Tab
              $isActive={activeTab === 'selection'}
              onClick={() => setActiveTab('selection')}
            >
              <CheckSquare
                size={25}
                color={activeTab === 'selection' ? '#0d6efd' : '#000'}
              />

              <p>Seleções para transferências</p>
            </Tab>

            <Tab
              $isActive={activeTab === 'list'}
              onClick={() => setActiveTab('list')}
            >
              <List
                size={25}
                color={activeTab === 'list' ? '#0d6efd' : '#000'}
              />
              <p>Lista de transferências</p>
            </Tab>
          </Tabs>

          {activeTab === 'selection' && (
            <>
              <FormPage>
                <p>Produto à ser transferido</p>

                <Group>
                  <CustomInput
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    height={40}
                    color="#dadada"
                    placeholder="Digite o SKU do produto..."
                    onKeyDown={(e) => {
                      if (search) {
                        if (e.key === 'Enter') {
                          searchProducts()
                        }
                      }
                    }}
                  />

                  <CustomButton
                    onClick={searchProducts}
                    isDisabled={!search}
                    styles={{ height: 35 }}
                    isLoading={isProductsLoading}
                  >
                    <MagnifyingGlass size={20} />
                  </CustomButton>
                </Group>

                <p>
                  {selectedProduct?.sku ? (
                    <>
                      Produto selecionado: {'\n'}
                      <strong>
                        {selectedProduct.sku} - {selectedProduct.descricao}
                      </strong>
                    </>
                  ) : (
                    `Nenhum produto selecionado!`
                  )}
                </p>
              </FormPage>

              <AddressSection>
                <AddressFrom>
                  {selectedProduct?.addresses?.length > 0 && (
                    <>
                      <AddressTitle>
                        {selectedProduct?.addresses.length > 1
                          ? 'Endereços'
                          : 'Endereço'}{' '}
                        do Produto
                      </AddressTitle>

                      <Table
                        responsive
                        hover
                        striped
                      >
                        <thead>
                          <tr>
                            <th></th>
                            <th>Cód.</th>
                            <th>Tipo End.</th>
                            <th>Dep.</th>
                            <th>Rua</th>
                            <th>Préd.</th>
                            <th>Nív.</th>
                            <th>Qtd</th>
                            <th>Qtd Pend. Saída</th>
                            <th>Qtd Pend. Entrada</th>
                          </tr>
                        </thead>

                        <tbody>
                          {selectedProduct.addresses.map((address) => (
                            <tr key={address.codendereco}>
                              <td>
                                <Form.Check
                                  checked={
                                    fromAddress.codendereco ===
                                    address.codendereco
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setFromAddress(address)
                                    } else {
                                      setFromAddress({})
                                    }
                                  }}
                                />
                              </td>
                              <td>{address.codendereco}</td>
                              <td>{address.tipoender}</td>
                              <td>{address.deposito}</td>
                              <td>{address.rua}</td>
                              <td>{address.predio}</td>
                              <td>{address.nivel}</td>
                              <td>{getValue(address.qt)}</td>
                              <td>{getValue(address.qtpendsaida)}</td>
                              <td>{getValue(address.qtpendentrada)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  )}
                </AddressFrom>

                <AddressTo>
                  {isAddressesLoading ? (
                    <div
                      style={{
                        display: 'flex',
                        height: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <CustomSpinner />
                    </div>
                  ) : (
                    <>
                      <AddressTitle>Endereços Disponíveis</AddressTitle>

                      <Row
                        className="mb-3"
                        style={{
                          marginTop: 25,
                        }}
                      >
                        <Col>
                          <Form.Control
                            placeholder="Cód."
                            name="codendereco"
                            value={searchAddress.codendereco}
                            onChange={handleChangeSearchAddress}
                          />
                        </Col>

                        <Col>
                          <Form.Select
                            name="tipoender"
                            value={searchAddress.tipoender}
                            onChange={handleChangeSearchAddress}
                          >
                            <option value="">Tipo</option>
                            <option value="AP">AP</option>
                            <option value="AE">AE</option>
                          </Form.Select>
                        </Col>

                        <Col>
                          <Form.Select
                            name="situacao"
                            value={searchAddress.situacao}
                            onChange={handleChangeSearchAddress}
                          >
                            <option value="">Situação</option>
                            <option value="L">Livre</option>
                            <option value="O">Ocupado</option>
                          </Form.Select>
                        </Col>

                        <Col>
                          <Form.Control
                            placeholder="Dep."
                            name="deposito"
                            value={searchAddress.deposito}
                            onChange={handleChangeSearchAddress}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <Form.Control
                            placeholder="Rua"
                            name="rua"
                            value={searchAddress.rua}
                            onChange={handleChangeSearchAddress}
                          />
                        </Col>

                        <Col>
                          <Form.Control
                            placeholder="Préd."
                            name="predio"
                            value={searchAddress.predio}
                            onChange={handleChangeSearchAddress}
                          />
                        </Col>

                        <Col>
                          <Form.Control
                            placeholder="Nív."
                            name="nivel"
                            value={searchAddress.nivel}
                            onChange={handleChangeSearchAddress}
                          />
                        </Col>

                        <Col>
                          <Form.Control
                            placeholder="Apto"
                            name="apto"
                            value={searchAddress.apto}
                            onChange={handleChangeSearchAddress}
                          />
                        </Col>

                        <Col>
                          <CustomButton
                            title="Pesquisar"
                            onClick={handleSearchAddress}
                            styles={{ height: 35 }}
                            isLoading={isAddressSearchLoading}
                            isLoadingText="Pesquisando..."
                            isDisabled={!selectedProduct.sku}
                          >
                            <MagnifyingGlass size={20} />
                          </CustomButton>
                        </Col>
                      </Row>

                      {filteredAddresses.length > 0 ? (
                        <>
                          <Table
                            responsive
                            hover
                            striped
                          >
                            <thead>
                              <tr>
                                <th></th>
                                <th>Cód.</th>
                                <th>Tipo End.</th>
                                <th>Dep.</th>
                                <th>Rua</th>
                                <th>Préd.</th>
                                <th>Nív.</th>
                                <th>Apto</th>
                                <th>Situação</th>
                              </tr>
                            </thead>

                            <tbody>
                              {filteredAddresses.map((address) => (
                                <tr key={address.codendereco}>
                                  <td>
                                    <Form.Check
                                      checked={
                                        toAddress.codendereco ===
                                        address.codendereco
                                      }
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setToAddress(address)
                                        } else {
                                          setToAddress({})
                                        }
                                      }}
                                    />
                                  </td>
                                  <td>{address.codendereco}</td>
                                  <td>{address.tipoender}</td>
                                  <td>{address.deposito}</td>
                                  <td>{address.rua}</td>
                                  <td>{address.predio}</td>
                                  <td>{address.nivel}</td>
                                  <td>{address.apto}</td>
                                  <td>{address.situacao}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>

                          <ReactPaginate
                            breakLabel="..."
                            nextLabel="Próxima"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={pageCount}
                            previousLabel="Anterior"
                            renderOnZeroPageCount={null}
                            containerClassName="pagination"
                            activeClassName="active"
                          />
                        </>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 20,
                          }}
                        >
                          <p>
                            {!selectedProduct.sku
                              ? 'Primeiro, selecione um produto para carregar os endereços.'
                              : 'Sem endereços.'}
                          </p>
                        </div>
                      )}
                    </>
                  )}
                </AddressTo>
              </AddressSection>
            </>
          )}

          {activeTab === 'list' &&
            (transfers.length === 0 ? (
              <ListPage>
                <p>Sem produtos na lista!</p>
              </ListPage>
            ) : (
              <>
                <Table
                  hover
                  striped
                >
                  <thead>
                    <tr>
                      <th>
                        <Form.Check
                          checked={addressesDelete.length === transfers.length}
                          onChange={(e) => {
                            if (e.target.checked) {
                              for (const addressTransfer of transfers) {
                                setAddressesDelete((prevState) => [
                                  ...prevState,
                                  addressTransfer.id,
                                ])
                              }
                            } else {
                              setAddressesDelete([])
                            }
                          }}
                        />
                      </th>
                      <th>SKU</th>
                      <th>Descrição</th>
                      <th>Qtd</th>
                      <th>Cód. (O)</th>
                      <th>Dep. (O)</th>
                      <th>Rua (O)</th>
                      <th>Préd. (O)</th>
                      <th>Nív. (O)</th>
                      <th>Cód. (D)</th>
                      <th>Dep (D)</th>
                      <th>Rua (D)</th>
                      <th>Préd. (D)</th>
                      <th>Nív. (D)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transfers.map((addressTransfer) => (
                      <tr key={addressTransfer.id}>
                        <td>
                          <Form.Check
                            checked={addressesDelete.includes(
                              addressTransfer.id,
                            )}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setAddressesDelete((prevState) => [
                                  ...prevState,
                                  addressTransfer.id,
                                ])
                              } else {
                                setAddressesDelete((prevState) =>
                                  prevState.filter(
                                    (id) => id !== addressTransfer.id,
                                  ),
                                )
                              }
                            }}
                          />
                        </td>
                        <td>{addressTransfer?.product?.sku}</td>
                        <td>{addressTransfer?.product?.descricao}</td>
                        <td>{addressTransfer?.quantity}</td>
                        <td>{addressTransfer?.fromAddress?.codendereco}</td>
                        <td>{addressTransfer?.fromAddress?.deposito}</td>
                        <td>{addressTransfer?.fromAddress?.rua}</td>
                        <td>{addressTransfer?.fromAddress?.predio}</td>
                        <td>{addressTransfer?.fromAddress?.nivel}</td>
                        <td>{addressTransfer?.toAddress?.codendereco}</td>
                        <td>{addressTransfer?.toAddress?.deposito}</td>
                        <td>{addressTransfer?.toAddress?.rua}</td>
                        <td>{addressTransfer?.toAddress?.predio}</td>
                        <td>{addressTransfer?.toAddress?.nivel}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            ))}
        </Content>

        <ButtonView>
          {activeTab === 'selection' ? (
            <CustomButton
              title="Adicionar à lista"
              isDisabled={!fromAddress.codendereco || !toAddress.codendereco}
              onClick={() => setIsModalConfirmQuantityOpen(true)}
            >
              <PlusCircleFill />
            </CustomButton>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CustomButton
                title="Transferir"
                isDisabled={transfers.length === 0}
                onClick={handleTransferAddresses}
                isLoading={isTransferAddressesLoading}
                isLoadingText="Transferindo..."
              >
                <HousesFill />
              </CustomButton>

              <CustomButton
                isDelete
                title="Excluir selecionados"
                isDisabled={addressesDelete.length === 0}
                onClick={() =>
                  Ask(
                    'Tem certeza que deseja excluir os produtos selecionados?',
                    handleRemoveAddresses,
                  )
                }
              >
                <TrashFill />
              </CustomButton>
            </div>
          )}
        </ButtonView>
      </Container>

      {isModalSelectProductOpen && (
        <ModalSelectProduct
          isOpen={isModalSelectProductOpen}
          onClose={() => setIsModalSelectProductOpen(false)}
          products={products}
          onSelectProduct={handleSelectProduct}
        />
      )}

      {isModalConfirmQuantityOpen && (
        <ModalConfirmQuantity
          isOpen={isModalConfirmQuantityOpen}
          onClose={() => setIsModalConfirmQuantityOpen(false)}
          fromAddress={fromAddress}
          toAddress={toAddress}
          onProcess={handleProductProcess}
        />
      )}
    </>
  )
}
